import React, { useContext } from 'react';
import styles from './ZavrsniRadoviNav.module.css';
import { ThemeContext } from '../contexts/ThemeContext';
import ZavrsniRadoviSearchForm from './ZavrsniRadoviSearchForm';
import ZavrsniRadoviPagination from './ZavrsniRadoviPagination';

const ZavrsniRadoviNav = ({filterRadovi, prikazSize, ukupanBrojRadova,
  prikazOffset, showNextPage, showPreviousPage, setSelectedCiklus, setSelectedStatus,
  selectedStatus, selectedCiklus}) => {
  const { dark } = useContext(ThemeContext);

  return (
    <div className={styles.zavrsniRadoviNav}>
      <div className={dark ? styles.filterHeaderDark : styles.filterHeaderLight}>
        <ZavrsniRadoviSearchForm 
          filterRadovi={filterRadovi} 
          setSelectedCiklus={setSelectedCiklus}
          setSelectedStatus={setSelectedStatus} 
          selectedCiklus={selectedCiklus}
          selectedStatus={selectedStatus}/>
        <ZavrsniRadoviPagination
          prikazSize={prikazSize}
          ukupanBrojRadova={ukupanBrojRadova}
          prikazOffset={prikazOffset}
          showNextPage={showNextPage}
          showPreviousPage={showPreviousPage} />
      </div>
    </div>
  );
}

export default ZavrsniRadoviNav;